import { useRef, useSyncExternalStore } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { isAxiosError } from 'axios'

export function useObservedFailedQueries() {
  const queryClient = useQueryClient()
  const failedQueriesMap = useRef(new Map<string, boolean>()).current

  return useSyncExternalStore(
    (cb) => {
      return queryClient.getQueryCache().subscribe((event) => {
        const query = event.query
        const hash = query.queryHash
        const { status } = query.state
        const isTfAppBefehlsnachricht =
          query.queryKey[0] === 'befehlsnachrichtUpdater'
        const isObserved =
          query.getObserversCount() > 0 || isTfAppBefehlsnachricht

        const isPeriodicQuery =
          isTfAppBefehlsnachricht ||
          query.observers.some((observer) => {
            const raw = observer.options.refetchInterval
            const resolved = typeof raw === 'function' ? raw(query) : raw
            return !!resolved
          })

        if (!isObserved || !isPeriodicQuery || status === 'success') {
          failedQueriesMap.delete(hash)
        } else if (status === 'error') {
          const error = query.state.error
          if (error && isAxiosError(error)) {
            if (error.request && !error.response) {
              // only network errors
              failedQueriesMap.set(hash, true)
            }
            if (error.response) {
              // server response was received
              failedQueriesMap.delete(hash)
            }
          }
        }

        cb()
      })
    },
    () => {
      return failedQueriesMap.size > 0
    }
  )
}
